import { forwardRef } from 'react';
import styled from '@emotion/styled';
import { ClipLoader } from 'react-spinners';
import { UnstyledTextEllipseWithTooltip } from 'components/UnstyledTextEllipseWithTooltip';
import Button from '.';

const StyledButton = styled(Button)`
  position: relative;
`;

const Label = styled('span', {
  shouldForwardProp: (prop) => prop !== 'isHidden',
})`
  display: contents;
  visibility: ${({ isHidden }) => (isHidden ? 'hidden' : 'visible')};
  font-size: inherit;
`;

const SpinnerOverlay = styled.span`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
`;

const LoadingButton = forwardRef(
  (
    {
      loading = false,
      loadingColor = 'var(--color-background-white)',
      disabled,
      children,
      ...rest
    },
    ref
  ) => (
    <StyledButton
      noSpace
      ref={ref}
      disabled={loading || disabled}
      aria-busy={loading || undefined}
      {...rest}
    >
      <Label isHidden={loading} aria-hidden={loading || undefined}>
        <UnstyledTextEllipseWithTooltip>
          {children}
        </UnstyledTextEllipseWithTooltip>
      </Label>
      {loading && (
        <SpinnerOverlay>
          <ClipLoader loading size={20} color={loadingColor} />
        </SpinnerOverlay>
      )}
    </StyledButton>
  )
);

LoadingButton.displayName = 'LoadingButton';

export default LoadingButton;
